import { ServerGameScene } from "../../../server/src/scenes/ServerGameScene";
import { PHYSICS } from "../../../shared/constants";
import type { LocalRoom } from "./LocalRoom";

// The authoritative simulation for offline play. It IS the real ServerGameScene
// (all server-side game logic reused verbatim), running in a separate headless
// Phaser.Game in the browser. Only two things differ from the server:
//   1. preload() loads assets over browser-relative URLs (no Node fs).
//   2. update() drives the LocalRoom state-sync tick after each simulation step.
export class OfflineGameScene extends ServerGameScene {
  localRoom: LocalRoom;

  preload() {
    const size = PHYSICS.TILE_SIZE;
    console.log(`[offline] loading map: ${this.selectedMapName}`);
    this.load.image('tileset', `./assets/tiles/tileset${size}.png`);
    this.load.json('mapData', `./assets/maps/${this.selectedMapName}.json`);
    this.load.json('tilesetData', `./assets/tiles/tileset${size}.json`);
  }

  create(): void {
    super.create();
    // World (map, stations, pillboxes) is now built — let the LocalRoom spawn
    // the local player and perform the initial state sync.
    this.localRoom.handleSceneCreated();
  }

  update(time: number, delta: number): void {
    super.update(time, delta);
    if (this.localRoom) {
      this.localRoom.flush();
    }
  }
}
